import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { scrollToId } from "./Header";

const NAV = [
  { id: "#expertises", label: "Expertises" },
  { id: "#profil", label: "Profil" },
  { id: "#prestations", label: "Prestations" },
  { id: "#faq", label: "FAQ" },
  { id: "#contact", label: "Contact" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-ink-line">
    <div className="mx-auto max-w-7xl px-6 pb-10 pt-16 lg:px-12">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo />
          <p className="mt-6 max-w-sm font-serif text-xl italic leading-relaxed text-ivory/80">
            « Conformité, sérénité, performance. »
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.26em] text-mute">
            Navigation
          </p>
          <ul className="mt-5 space-y-3">
            {NAV.map((n) => (
              <li key={n.id}>
                <a
                  href={n.id}
                  data-testid={`footer-${n.label.toLowerCase()}-link`}
                  onClick={(e) => scrollToId(e, n.id)}
                  className="text-sm text-ivory/75 transition-colors duration-300 hover:text-gold"
                >
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.26em] text-mute">
            Coordonnées
          </p>
          <ul className="mt-5 space-y-3 text-sm text-ivory/75">
            <li>
              <a href="tel:+33621133049" data-testid="footer-phone-link" className="transition-colors duration-300 hover:text-gold">
                +33 6 21 13 30 49
              </a>
            </li>
            <li>
              <a href="mailto:lehilamugobe@gmail.com" data-testid="footer-email-link" className="transition-colors duration-300 hover:text-gold">
                lehilamugobe@gmail.com
              </a>
            </li>
            <li>Adresse postale : 138 avenue Victor Hugo, 75016 Paris</li>
            <li>Interventions en présentiel et à distance</li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-ink-line pt-7 sm:flex-row sm:items-center">
        <p className="text-xs text-mute">
          © 2026 ALMALEX Legal Consulting — Tous droits réservés
        </p>
        <Link
          to="/mentions-legales"
          data-testid="footer-legal-link"
          className="text-xs text-mute underline-offset-4 transition-colors duration-300 hover:text-gold hover:underline"
        >
          Mentions légales & politique de confidentialité
        </Link>
      </div>
    </div>
    <div
      aria-hidden="true"
      className="pointer-events-none select-none whitespace-nowrap text-center font-serif text-[19vw] font-semibold leading-[0.75] tracking-tight text-ivory/[0.05]"
    >
      ALMALEX
    </div>
  </footer>
);
